<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div class="name-container">
      <span>{{ title }}</span>
      <div class="btn-grp">
        <input class="main-btn" type="submit" value="Go Back" (click)="goBack()" />
        <input class="main-btn ms-2" type="submit" value="Save Changes" (click)="saveChanges()" />
      </div>
    </div>
    <div class="details">
      <div class="heading">
        <span class="sub-heading">SKILL DETAILS</span>
        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group skill-detail-field">
          <label class="skill-field-label" for="skillType">Skill Type</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="skillType"
            placeholder="Skill Type"
            [value]="skillDetail?.Type"
          />
        </div>

        <div class="form-group skill-detail-field">
          <label class="skill-field-label" for="skillName">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="skillName"
            placeholder="Name"
            [value]="skillDetail?.Name"
          />
        </div>

        <div class="form-group skill-detail-field">
          <label class="skill-field-label" for="skillDescription">Description</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="skillDescription"
            placeholder="Description"
            [value]="skillDetail?.Description"
          />
        </div>

        <div class="form-group skill-detail-field">
          <label class="skill-field-label" for="createdOn">Created On</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="createdOn"
            placeholder="Created On"
            [value]="skillDetail?.Created | custdate"
          />
        </div>

        <div class="form-group skill-detail-field">
          <label class="skill-field-label" for="lastUpdatedOn">Last Updated On</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="lastUpdatedOn"
            placeholder="Last Updated On"
            [value]="skillDetail?.LastUpdated | custdate"
          />
        </div>

        <div class="sla-window-ctrls">
          <app-assign-agents [details]="details"></app-assign-agents>
        </div>
      </div>
    </div>
  </div>
</div>
